@let agreementTermsText = agreementTermsText$ | async; 

<div mat-dialog-content>

    @if(agreementTermsText) {
        <ng-container>
            <p>{{agreementTermsText}}</p>
        </ng-container>
    }
    @else {
        <ng-container *ngTemplateOutlet="loading" />
    }

</div>
<mat-dialog-actions class="footer">
  <button type="button" class="button-basic" (click)="acceptAction()">
    {{'UnfoundedDebtCaseDialog.Accept' | translate}}
  </button>

  <button type="button" class="button-red" (click)="cancelAction()">
    {{'UnfoundedDebtCaseDialog.Cancel' | translate}}
  </button>
</mat-dialog-actions>

<ng-template #loading>
  <mat-progress-bar class="progress-bar-margin-top" mode="indeterminate"></mat-progress-bar>
</ng-template>